import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { ActivatedRoute, Router } from '@angular/router';
import { map, take, tap } from 'rxjs';
import { IsNotUserDirective } from 'src/app/directves/is-not-user.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { StepComponent } from './step/step.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoggedUserComponent } from 'src/app/shared/components/logged-user/logged-user.component';
import { StepperComponent } from './stepper/stepper.component';

@Component({
    selector: 'que-steps-menu',
    imports: [CommonModule, MatButtonToggleModule, TranslateDirective, TranslatePipe, IsNotUserDirective, ReactiveFormsModule, StepComponent, StepperComponent, LoggedUserComponent],
    templateUrl: './steps-menu.component.html',
    styleUrls: ['./steps-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepsMenuComponent implements OnInit {
  @Input()
  isPreview = false;
  @Input()
  inMobile = false;
  @Output()
  closeMenuEvent = new EventEmitter();
  #questionnaireStore = inject(QuestionnaireStore);
  #router = inject(Router);

  notLoading$ = toSignal(this.#questionnaireStore.notLoading$);
  stepsNames$ = toSignal(this.#questionnaireStore.steps$.pipe(
    map(x => x.map(s => s.title))
  ));
  currentStep$ = toSignal(this.#questionnaireStore.currentStepIndex$);

  changePage(i: number) {
    this.#questionnaireStore.updateCurrentStepIndex(i);
    if(this.inMobile){
    this.closeMenuEvent.emit();
    }
  }
  ngOnInit(): void {
    this.isPreview = this.#router.url.includes("preview") || this.#router.url.includes("answer") || this.#router.url.includes("viewAnswers");
  }
}
